// extracted by mini-css-extract-plugin
export default {"wrapper":"PrepayRequireDialog--wrapper--13ee49","content":"PrepayRequireDialog--content--acf1f0","buttonSpacing":"PrepayRequireDialog--buttonSpacing--4f3058"};